import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PatientMessage.module.css';
import {  setChatList, setChatVisible, setNewChat, setSelectedIndex, setRecipient } from './PatientMessageSlicer';
import PatientMessageList from './PatientMessageList';
import FilterChatView from '../../components/FilterChatView';
import managementStyles from '../ManagementPages.module.css';
import useAxios from '../../services/AxiosConfig';
import { resetFilterState } from '../../slicers/FilterChatSlice';

const PatientMessage = () => {
    const dispatch = useDispatch();
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const userId = useSelector((state) => state.userInfo.id);
    const [patients, setPatients] = useState([]);
    

    const onNewMessageHandler = () => {
        dispatch(setSelectedIndex(-1));
        dispatch(setChatList([]));
        dispatch(setChatVisible(true));
        dispatch(setNewChat(true));
    }

    const handleChatContainerClose = () => {
        dispatch(setChatVisible(false));
        dispatch(setSelectedIndex(-1));
        dispatch(setChatList([]));
        dispatch(setNewChat(false));
        dispatch(setRecipient({ 'id': 0, name: "" }));
    };

    const fetchPatients = async () => {
        const patients = await axios.get(`/enrollment/list/patient/${userId}`);
        if (Array.isArray(patients.data.data)) {
            const formattedPatients = patients.data.data.map(patient => ({
                id: patient.id,
                name: patient.firstName + " " + patient.lastName,
                organizationIds: patient.groups.map(group => group.organizationId),
                groupIds: patient.groups.map(group => group.groupId),
                subGroupIds: patient.groups.map(group => group.subGroupId),
                teamIds: patient.groups.map(group => group.teamId),
            }));
            setPatients(formattedPatients);
        }
    }

    useEffect(() => {
        fetchPatients();
        dispatch(resetFilterState());
    }, []);

    return (
        <div className={managementStyles.MiddleContent}>
            <div className={styles.FilterContainer}>
                <FilterChatView
                    view='PatientMessage'
                    isOrganization={true}
                    isGroup={true}
                    isSubGroup={true}
                    isTeam={true}
                    showDeleteButton={false}
                    addButtonLabel={'New Message'}
                    onAddHandler={onNewMessageHandler}
                />
                <PatientMessageList
                    onCloseClick={handleChatContainerClose}
                    patients={patients}
                />
            </div>
        </div>
    );
};

export default PatientMessage;
